import React from 'react';
import { Alert, Button } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('🚨 Error Boundary capturó un error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

  }

  handleReload = () => {
    window.location.reload();
  }

  handleClearStorage = () => {
    try {
      sessionStorage.clear();
      localStorage.clear();
      window.location.reload();
    } catch (e) {
      console.error('Error al limpiar almacenamiento:', e);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          margin: '50px auto', 
          maxWidth: '800px',
          fontFamily: 'Arial, sans-serif'
        }}>
          <Alert variant="danger">
            <Alert.Heading>🚨 Error en la Aplicación</Alert.Heading>
            <p>
              La aplicación encontró un error inesperado y no pudo continuar. 
              Esto puede deberse a un problema temporal o a una configuración incorrecta.
            </p>
          </Alert>

          <div style={{ marginTop: '20px' }}>
            <h4>🔧 Opciones para solucionar:</h4>
            <div style={{ marginTop: '10px' }}>
              <Button 
                variant="primary" 
                onClick={this.handleReload}
                style={{ marginRight: '10px', marginBottom: '10px' }}
              >
                🔄 Recargar Página
              </Button>
              <Button 
                variant="warning" 
                onClick={this.handleClearStorage}
                style={{ marginRight: '10px', marginBottom: '10px' }}
              >
                🧹 Limpiar Caché y Recargar
              </Button>
              <Button 
                variant="info" 
                onClick={() => window.location.href = '/login'}
                style={{ marginBottom: '10px' }}
              >
                🔐 Ir al Login
              </Button>
            </div>
          </div>

          <details style={{ marginTop: '20px' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              📋 Ver información técnica del error
            </summary>
            <div style={{ 
              marginTop: '10px', 
              padding: '10px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '5px',
              fontSize: '12px',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
              maxHeight: '300px',
              overflow: 'auto'
            }}>
              <strong>Error:</strong>
              {this.state.error && this.state.error.toString()}
              
              <br /><br />
              <strong>Stack Trace:</strong>
              {this.state.errorInfo.componentStack}
              
              <br /><br />
              <strong>Información del navegador:</strong>
              {JSON.stringify({
                url: window.location.href,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString(),
                localStorage: Object.keys(localStorage).length,
                sessionStorage: Object.keys(sessionStorage).length
              }, null, 2)}
            </div>
          </details>

          <Alert variant="info" style={{ marginTop: '20px' }}>
            <Alert.Heading>💡 Si el problema persiste:</Alert.Heading>
            <ul>
              <li>Verifica que tienes conexión a internet estable</li>
              <li>Intenta acceder en modo incógnito</li>
              <li>Limpia la caché y cookies del navegador</li>
              <li>Contacta al soporte técnico si el problema continúa</li>
            </ul>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
